import { render, staticRenderFns } from "./AlarmTimeUnitSelect.vue?vue&type=template&id=63d171d4"
import script from "./AlarmTimeUnitSelect.vue?vue&type=script&lang=js"
export * from "./AlarmTimeUnitSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports